<template>
  <div id="wrap">
    <div class="dashboard clear">
      <Toolbar :menuInfo="menuInfo"></Toolbar>
      <div class="right">
        <Navigation :menuInfo="menuInfo"></Navigation>
        <div class="main">
          <div class="main-nav">
            <ContentsNavigation v-if="false && (menuInfo.company || menuInfo.device)" :menuInfo="menuInfo" @selectNode="selectNode"></ContentsNavigation>
          </div>
          <div class="board clear">
            <TreeView
              :treeType="treeType"
              :treeScope="treeScope"
              :refreshEvent="refreshEvent"
              @selectNode="selectNode"
            ></TreeView>

            <div class="list">
              <SaleList
                class="sale-list"
                :deviceID="deviceID"
                :selectEvent="selectEvent"
              ></SaleList>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-bitwise */
/* eslint-disable no-console */

import Toolbar from '@/components/include/Toolbar';
import Navigation from '@/components/include/Navigation';
import ContentsNavigation from '@/components/include/ContentsNavigation';
import TreeView from '@/components/include/TreeView';
import SaleList from '@/components/sale/SaleList';

export default {
  components: {
    Toolbar,
    Navigation,
    ContentsNavigation,
    TreeView,
    SaleList,
  },
  data: () => ({
    menu: null,
    company: null,
    device: null,
    deviceID: '',
    selectEvent: 0,
    refreshEvent: 0,
    treeType: 'device',
    treeScope: 'biz',
    menuInfo: {
      mainTitle: 'DeviceSale',
      mainName: '메인 가맹점',
      subTitle: '',
      subName: '',
      company: null,
      division: null,
      device: null,
      tray: null,
      product: null,
    },
  }),
  created() {
    this.menu = this.$route.name;
  },
  methods: {
    selectNode(object, type) {
      if (type === 'device') {
        this.company = null;
        this.device = object;
        this.deviceID = object.id;
        this.selectEvent ^= 1;
      }
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/sale/DeviceSale.vue